import React, { useState, useEffect } from 'react'
import { Steps, Space} from 'antd'
import { useFYspListQuery } from '../../store/DianShangYeWuApi';
import ExpenseNodeCheckApprove from './ExpenseNodeCheckApprove';
import ExpenseNodeCheckEdit from './ExpenseNodeCheckEdit';
function ExpenseNodeCheck(props) {
    const [items, setItems] = useState([])
    const {data, isSuccess} = useFYspListQuery({fy_sp_fy_id:props.fy_id},{skip:!props.fy_id})
    const [current, setCurrent] = useState(0);
    useEffect(() => {
        if(isSuccess && data.Status === 'success'){
            // 然后 map，判断是否是最后一个元素
            const newArr =  data.Result.map(item => {
                const {
                    fy_sp_jd_name,
                    fy_sp_yh_name,
                    fy_sp_yh_id,
                    fy_sp_jd_xuhao,
                    fy_sp_content,
                    fy_sp_id,
                    fy_sp_dsbzd_id,
                    fy_sp_dsbzd_name,
                    fy_sp_state,
                    fy_sp_state_time,
                    fy_sp_uname,
                    fy_sp_ctime,
                    fy_sp_dsbzd_date,
                    fy_sp_dsbzd_date_end,
                    fy_sp_dsbzd_kh_id,
                    fy_sp_dsbzd_kh_name,
                } = item;
                return {
                    fy_sp_jd_name,
                    fy_sp_yh_name,
                    fy_sp_yh_id,
                    fy_sp_jd_xuhao,
                    fy_sp_content,
                    fy_sp_id,
                    fy_sp_dsbzd_id,
                    fy_sp_dsbzd_name,
                    fy_sp_state,
                    fy_sp_state_time,
                    fy_sp_uname,
                    fy_sp_ctime,
                    fy_sp_dsbzd_date,
                    fy_sp_dsbzd_date_end,
                    fy_sp_dsbzd_kh_id,
                    fy_sp_dsbzd_kh_name,
                }                
            })
            // 排序数据
            const sortedData = newArr.sort((a, b) => {
                return a.fy_sp_jd_xuhao - b.fy_sp_jd_xuhao;
            });
            // 生成 arr 并计算 current
            let firstApproveWithState2Index = -1; // 在 arr 中的索引（状态为 '2' 的审批点）
            let lastItemIndex = -1; // 在 arr 中的最后一个 item 的索引
            let arrIndex = 0; // arr 的当前索引
            
            const arr = sortedData.map((item) => {
                let result = null;
                if(item.fy_sp_jd_name === '审批' && item.fy_sp_state==='1'){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>审批</span>,
                        content:<span style={{fontSize:"12px"}}>{item.fy_sp_yh_name}</span>,
                        fy_sp_state:item.fy_sp_state,
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                else if(item.fy_sp_jd_name === '审批' && item.fy_sp_state==='2'){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>审批</span>,
                        content:props.yh_id===item.fy_sp_yh_id ? <ExpenseNodeCheckApprove 
                                                                        sortedData={sortedData}
                                                                        yh_id={props.yh_id} 
                                                                        yh_name={props.yh_name} 
                                                                        fy_id={props.fy_id}
                                                                        fy_date={props.fy_date}
                                                                        fy_kh_id={props.fy_kh_id}
                                                                        fy_kh_name={props.fy_kh_name}
                                                                        fy_sp_id={item.fy_sp_id}
                                                                        fy_sp_jd_xuhao={item.fy_sp_jd_xuhao}
                                                                        fy_sp_jd_name={item.fy_sp_jd_name}
                                                                        fy_sp_yh_id={item.fy_sp_yh_id}
                                                                        fy_sp_yh_name={item.fy_sp_yh_name}
                                                                        fy_sp_uid={item.fy_sp_uid}
                                                                        fy_sp_uname={item.fy_sp_uname}
                                                                    /> : <span style={{fontSize:"12px"}}>{item.fy_sp_yh_name}</span>,
                        fy_sp_state:item.fy_sp_state,
                                                                    
                    }
                    // 找到第一个状态为 '2' 的审批点
                    if(firstApproveWithState2Index === -1){
                        firstApproveWithState2Index = arrIndex;
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                else if(item.fy_sp_jd_name === '审批' && (item.fy_sp_state==='3' || item.fy_sp_state==='4' || item.fy_sp_state==='5')){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>审批</span>,
                        content:props.yh_id===item.fy_sp_yh_id ? <ExpenseNodeCheckEdit 
                                                                        sortedData={sortedData}
                                                                        yh_id={props.yh_id} 
                                                                        yh_name={props.yh_name} 
                                                                        fy_id={props.fy_id}
                                                                        fy_date={props.fy_date}
                                                                        fy_kh_id={props.fy_kh_id}
                                                                        fy_kh_name={props.fy_kh_name}
                                                                        fy_sp_id={item.fy_sp_id}
                                                                        fy_sp_jd_xuhao={item.fy_sp_jd_xuhao}
                                                                        fy_sp_jd_name={item.fy_sp_jd_name}
                                                                        fy_sp_yh_id={item.fy_sp_yh_id}
                                                                        fy_sp_yh_name={item.fy_sp_yh_name}
                                                                        fy_sp_uid={item.fy_sp_uid}
                                                                        fy_sp_uname={item.fy_sp_uname}
                                                                        fy_sp_state={item.fy_sp_state}
                                                                        fy_sp_state_time={item.fy_sp_state_time}
                                                                        fy_sp_content={item.fy_sp_content}
                                                                    />: <Space orientation='vertical' size={0}>
                                                                            <span style={{color:item.fy_sp_state==='4' ? 'red' : 'green',fontWeight:"bold"}}>
                                                                                {item.fy_sp_state==='4' ? '驳回' : '同意'}
                                                                                {item.fy_sp_content? '：'+item.fy_sp_content :''}
                                                                            </span>
                                                                            <span>{item.fy_sp_yh_name} {item.fy_sp_state_time} </span>
                                                                        </Space>,
                                                                        fy_sp_state:item.fy_sp_state,
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                else if(item.fy_sp_jd_name === '抄送' && item.fy_sp_state==='1'){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>抄送</span>,
                        content:<span style={{fontSize:"12px"}}>{item.fy_sp_yh_name}</span>,
                        fy_sp_state:item.fy_sp_state,
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                else if(item.fy_sp_jd_name === '抄送' && item.fy_sp_state==='2'){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>抄送</span>,
                        content:<span style={{fontSize:"12px"}}>{item.fy_sp_yh_name}</span>,
                        fy_sp_state:item.fy_sp_state,
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                else if(item.fy_sp_jd_name === '抄送' && item.fy_sp_state==='3'){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>抄送</span>,
                        content:<span style={{fontSize:"12px"}}>{item.fy_sp_yh_name} {item.fy_sp_state_time}</span>,
                        fy_sp_state:item.fy_sp_state,
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                return result;
            })
            
            // 计算 current，规则优先级：'2' > '4' > 最后一个
            let calculatedCurrent = 0;
            let firstApproveWithState4Index = -1;

            // 查找 '2' 和 '4' 的索引
            arr.forEach((item, idx) => {
                if (item && item.fy_sp_state === '2' && firstApproveWithState2Index === -1) {
                    firstApproveWithState2Index = idx;
                }
                if (item && item.fy_sp_state === '4' && firstApproveWithState4Index === -1) {
                    firstApproveWithState4Index = idx;
                }
            });

            if (firstApproveWithState2Index !== -1) {
                calculatedCurrent = firstApproveWithState2Index;
            } else if (firstApproveWithState4Index !== -1) {
                calculatedCurrent = firstApproveWithState4Index;
            } else if (lastItemIndex !== -1) {
                calculatedCurrent = lastItemIndex;
            }

            // current 需要加上前面的"创建"和"提交"两个步骤
            setCurrent(calculatedCurrent + 2);
            setItems([{
                title:<span style={{fontSize:"14px",fontWeight:"bold"}}>创建</span>,
                content:<span style={{fontSize:"14px"}}>{props.fy_uname} {props.fy_ctime}</span>,
            },
            {
                title:<span style={{fontSize:"14px",fontWeight:"bold"}}>提交</span>,
                content:<span style={{fontSize:"14px"}}>{props.fy_uname} {props.fy_state_time}</span>,
            },...arr]);
        }else{
            setItems([]);
        }
        
        
    },[data, isSuccess,props.fy_id,props.fy_uname,props.fy_ctime,props.fy_state_time,props.fy_date,props.fy_kh_id,props.fy_kh_name,props.yh_id,props.yh_name])
    return (
        <Steps 
            items={items} 
            current={current} 
            size="small" 
            titlePlacement="vertical" 
        />
    )
}

export default ExpenseNodeCheck